import React from 'react';
import PropTypes from 'prop-types';
import { Button, withStyles } from '@material-ui/core';

const styles = theme => ({
    button: {
        marginRight: theme.spacing(2),
    },
});

const ButtonSubmit = ({
    title,
    classes,
    ...otherProps
}) => (
    <Button
        size="large"
        variant="contained"
        color="default"
        className={classes.button}
        {...otherProps}
    >
        {title}
    </Button>
);

ButtonSubmit.propTypes = {
    classes: PropTypes.objectOf(PropTypes.any).isRequired,
    title: PropTypes.string.isRequired,
};
export default withStyles(styles)(ButtonSubmit);
